import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getContactPreferencesV2, updateContactPreferencesV2 } from '../services/ContactPreferencesV2Service';

export const useContactPreferencesV2GetContactPreferencesV2 = createDCHook(
  'getContactPreferencesV2',
  collapseDataFromCall(getContactPreferencesV2),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useContactPreferencesV2UpdateContactPreferencesV2 = createMutationHook(
  collapseParams(
    collapseParams(updateContactPreferencesV2, 'requestBody', 'data'),
    'data',
    'merContactPreference',
    'traditionalMeterReadNotificationContactPreference',
    'contactByTelephone',
    'customerExperienceOpinion',
    'useCustomerData',
    'productOffersFirstPartySubscribed',
    'productOffersThirdParty',
    'newsletter',
    'invoicesByEmail',
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'merContactPreference',
          'traditionalMeterReadNotificationContactPreference',
          'contactByTelephone',
          'customerExperienceOpinion',
          'useCustomerData',
          'productOffersFirstPartySubscribed',
          'productOffersThirdParty',
          'newsletter',
          'invoicesByEmail',
        ],
      },
    ],
  },
);
